export const CARD_SCROLLBAR_GAP_PX = 24;
export const CARD_SCROLLBAR_THUMB_HEIGHT_PX = 146;
export const CARD_SCROLLBAR_WIDTH_PX = 8;
export const EXPERIENCE_CARD_RESTING_LEFT_INSET_PX = 24;
export const EXPERIENCE_CARD_RESTING_RIGHT_INSET_PX = 32;
